import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    component: () => import('../views/Dashboard.vue'),
    children: [
      {
        path: '',
        name: 'DashboardHome',
        component: () => import('../components/Home.vue')
      },
      {
        path: 'all-calculators',
        name: 'DashboardAll',
        component: () => import('../components/DefaultView.vue')
      },
      {
        path: 'tax-salary-calculators',
        name: 'TaxSalaryCalculators',
        component: () => import('../components/TaxSalaryCalculators.vue')
      },
      {
        path: 'retirement-calculators',
        name: 'RetirementCalculators',
        component: () => import('../components/RetirementCalculators.vue')
      },
      {
        path: 'mortgage-RE-calculators',
        name: 'MortgageRECalculators',
        component: () => import('../components/MortgageRECalculators.vue')
      },
      {
        path: 'investment-calculators',
        name: 'InvestmentCalculators',
        component: () => import('../components/InvestmentCalculators.vue')
      },
      {
        path: 'auto-calculators',
        name: 'AutoCalculators',
        component: () => import('../components/AutoCalculators.vue')
      },
      {
        path: 'other-calculators',
        name: 'OtherCalculators',
        component: () => import('../components/OtherCalculators.vue')
      },{
        path: 'crypto-calculators',
        name: 'CryptoCalculators',
        component: () => import('../components/CryptoCalculators.vue')
      },
      {
        path: 'annuity-calculators',
        name: 'AnnuityCalculators',
        component: () => import('../components/AnnuityCalculators.vue')
      },
      {
        path: 'global-vat',
        name: 'GlobalPriceCalculator',
        component: () => import('../components/GlobalPriceCalculator.vue'),
        meta: { keepAlive: false } // 确保不缓存
      },
      {
        path: 'paycheck',
        name: 'PaycheckCalculator',
        component: () => import('../components/PaycheckCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'income-tax',
        name: 'IncomeTaxCalculator',
        component: () => import('../components/IncomeTaxCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'take-home-paycheck-calculator',
        name: 'TakeHomePaycheckCalculator',
        component: () => import('../components/TakeHomePaycheckCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'crypto-tax-calculator',
        name: 'CryptoTaxCalculator',
        component: () => import('../components/CryptoTaxCalculator.vue'),
        meta: { keepAlive: false }
      }, 
      {
        path: 'nft-calculator',
        name: 'NFTCalculator',
        component: () => import('../components/NFTCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'usa-crypto-calculator',
        name: 'USACryptoCalculator',
        component: () => import('../components/USACryptoCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'uk-crypto-calculator',
        name: 'UKCryptoTaxCalculator',
        component: () => import('../components/UKCryptoTaxCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'canada-crypto-calculator',
        name: 'CanadaCryptoTaxCalculator',
        component: () => import('../components/CanadaCryptoTaxCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'australia-crypto-calculator',
        name: 'AustraliaCryptoTaxCalculator',
        component: () => import('../components/AustraliaCryptoTaxCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'marriage-tax-calculator',
        name: 'MarriageTaxCalculator',
        component: () => import('../components/MarriageTaxCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'salary-calculator',
        name: 'SalaryCalculator',
        component: () => import('../components/SalaryCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'retirement',
        name: 'RetirementCalculator',
        component: () => import('../components/RetirementCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: '401k',
        name: '401KCalculator',
        component: () => import('../components/401KCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'pension',
        name: 'PensionCalculator',
        component: () => import('../components/PensionCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'social-security',
        name: 'SocialSecurityCalculator',
        component: () => import('../components/SocialSecurityCalculator.vue'),
        meta: { keepAlive: false }
      },
       {
        path: 'annuity',
        name: 'AnnuityCalculator',
        component: () => import('../components/AnnuityCalculator.vue'),
        meta: { keepAlive: false }
      },
       {
        path: 'annuity-payout',
        name: 'AnnuityPayoutCalculator',
        component: () => import('../components/AnnuityPayoutCalculator.vue'),
        meta: { keepAlive: false }
      },
       {
        path: 'roth-ira',
        name: 'RothIRACalculator',
        component: () => import('../components/RothIRACalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'ira-calculator',
        name: 'IRACalculator',
        component: () => import('../components/IRACalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'deferred-annuity',
        name: 'DeferredAnnuityCalculator',
        component: () => import('../components/DeferredAnnuityCalculator.vue'),
        meta: { keepAlive: false }
      },
       {
        path: 'mortgage',
        name: 'MortgageCalculator',
        component: () => import('../components/MortgageCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'mortgage-payoff',
        name: 'MortgagePayoffCalculator',
        component: () => import('../components/MortgagePayoffCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'house-affordability-calculator',
        name: 'HouseAffordabilityCalculator',
        component: () => import('../components/HouseAffordabilityCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'fixed-house-affordability-calculator',
        name: 'FixedHouseAffordabilityCalculator',
        component: () => import('../components/FixedHouseAffordabilityCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'amortization',
        name: 'AmortizationCalculator',
        component: () => import('../components/AmortizationCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'investment',
        name: 'Investmentcalculator',
        component: () => import('../components/Investmentcalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'interest',
        name: 'InterestCalculator',
        component: () => import('../components/InterestCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'certificate-deposit',
        name: 'CertificateDepositCalculator',
        component: () => import('../components/CertificateDepositCalculator.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'about-us',
        name: 'AboutUs',
        component: () => import('../footlink/AboutUs.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'terms-of-use',
        name: 'TermsOfUse',
        component: () => import('../footlink/TermsOfUse.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'privacy-policy',
        name: 'PrivacyPolicy',
        component: () => import('../footlink/PrivacyPolicy.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'blog',
        name: 'Blog',
        component: () => import('../components/Blog.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'vat-gst-sales-tax-blog',
        name: 'VatGstSalesTax',
        component: () => import('../blog/VatGstSalesTax.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'social-security-blog',
        name: 'SocialSecurity',
        component: () => import('../blog/SocialSecurity.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'bt-at-income-blog',
        name: 'BTvsATIncome',
        component: () => import('../blog/BTvsATIncome.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'general-annuity-info-blog',
        name: 'GeneralAnnuityInfo',
        component: () => import('../blog/GeneralAnnuityInfo.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'marriage-tax-penalty-blog',
        name: 'MarriageTaxPenalty',
        component: () => import('../blog/MarriageTaxPenalty.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'when-should-you-claim-social-security-blog',
        name: 'WhenShouldYouClaimSocialSecurity',
        component: () => import('../blog/WhenShouldYouClaimSocialSecurity.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'how-long-will-last-in-retirement-blog',
        name: 'HowLongWillLastInRetirement',
        component: () => import('../blog/HowLongWillLastInRetirement.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'vat-vs-gst-vs-sales-tax-a-global-comparison-table-blog',
        name: 'VATvsGSTvsSalesTaxAGlobalComparisonTable',
        component: () => import('../blog/VATvsGSTvsSalesTaxAGlobalComparisonTable.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'the-hidden-cost-of-filing-taxes-jointly-vs-separately-blog',
        name: 'TheHiddenCostofFilingTaxesJointlyvsSeparately',
        component: () => import('../blog/TheHiddenCostofFilingTaxesJointlyvsSeparately.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'how-much-house-can-i-afford-blog',
        name: 'HowMuchHouseCanIAfford',
        component: () => import('../blog/HowMuchHouseCanIAfford.vue'),
        meta: { keepAlive: false }
      },
      {
        path: '30-year-vs-15-year-mortgage-blog',
        name: '30-Yearvs15-YearMortgage',
        component: () => import('../blog/30-Yearvs15-YearMortgage.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'how-mortgage-payments-are-calculated-blog',
        name: 'HowMortgagePaymentsAreCalculated',
        component: () => import('../blog/HowMortgagePaymentsAreCalculated.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'what-is-an-amortization-schedule-blog',
        name: 'WhatIsanAmortizationSchedule',
        component: () => import('../blog/WhatIsanAmortizationSchedule.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'crypto-tax-calculator-estimate-bitcoin-crypto-capital-gains-blog',
        name: 'CryptoTaxCalculatorEstimateBitcoinCryptoCapitalGains',
        component: () => import('../blog/CryptoTaxCalculatorEstimateBitcoinCryptoCapitalGains.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'ultimate-investment-calculator-guide-maximize-your-returns-in-2026-blog',
        name: 'UltimateInvestmentCalculatorGuideMaximizeYourReturnsin2026',
        component: () => import('../blog/UltimateInvestmentCalculatorGuideMaximizeYourReturnsin2026.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'how-to-calculate-intereston-savings-blog',
        name: 'HowtoCalculateInterestonSavings',
        component: () => import('../blog/HowtoCalculateInterestonSavings.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'roth-ira-calculator-estimate-your-tax-free-retirement-growth-blog',
        name: 'RothIRACalculatorEstimateYourTaxFreeRetirementGrowth',
        component: () => import('../blog/RothIRACalculatorEstimateYourTaxFreeRetirementGrowth.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'crypto-taxes-in-the-usa-blog',
        name: 'CryptoTaxesInTheUSA',
        component: () => import('../blog/CryptoTaxesInTheUSA.vue'),
        meta: { keepAlive: false } 
      },
      {
        path: 'how-to-calculate-certificate-of-deposit-interest-blog',
        name: 'HowtoCalculateCertificateofDepositInterest',
        component: () => import('../blog/HowtoCalculateCertificateofDepositInterest.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'why-is-my-paycheck-so-much-lower-than-my-salary-blog',
        name: 'WhyIsMyPaycheckSoMuchLowerThanMySalary',
        component: () => import('../blog/WhyIsMyPaycheckSoMuchLowerThanMySalary.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'how-much-is-your-salary-per-hour-blog',
        name: 'HowMuchIsYourSalaryPerHour',
        component: () => import('../blog/HowMuchIsYourSalaryPerHour.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'how-much-will-you-have-at-retirement-blog',
        name: 'HowMuchWillYouHaveatRetirement',
        component: () => import('../blog/HowMuchWillYouHaveatRetirement.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'how-much-will-you-get-each-month-in-retirement-blog',
        name: 'HowMuchWillYouGetEachMonthinRetirement',
        component: () => import('../blog/HowMuchWillYouGetEachMonthinRetirement.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'annuity-rule-which-gives-you-more-monthly-income-blog',
        name: 'AnnuityRuleWhichGivesYouMoreMonthlyIncome',
        component: () => import('../blog/AnnuityRuleWhichGivesYouMoreMonthlyIncome.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'uk-crypto-tax-7rules-that-could-save-you-thousands-blog',
        name: 'UKCryptoTax7RulesThatCouldSaveYouThousands',
        component: () => import('../blog/UKCryptoTax7RulesThatCouldSaveYouThousands.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'do-you-pay-tax-on-nfts-5-things-every-investor-must-know-blog',
        name: 'DoYouPayTaxonNFTs5ThingsEveryInvestorMustKnow',
        component: () => import('../blog/DoYouPayTaxonNFTs5ThingsEveryInvestorMustKnow.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'mortgage-how-fast-can-you-pay-it-off-with-extra-payments-blog',
        name: 'MortgageHowFastCanYouPayItOffwithExtraPayments',
        component: () => import('../blog/MortgageHowFastCanYouPayItOffwithExtraPayments.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'how-to-calculate-crypto-tax-in-canada-blog',
        name: 'HowtoCalculateCryptoTaxinCanada',
        component: () => import('../blog/HowtoCalculateCryptoTaxinCanada.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'do-you-pay-tax-on-crypto-in-australia-5ato-rules-explained-blog',
        name: 'DoYouPayTaxonCryptoinAustralia5ATORulesExplained',
        component: () => import('../blog/DoYouPayTaxonCryptoinAustralia5ATORulesExplained.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'how-much-will-your-ira-be-worth-blog',
        name: 'HowMuchWillYourIRABeWorth',
        component: () => import('../blog/HowMuchWillYourIRABeWorth.vue'),
        meta: { keepAlive: false }
      },
      {
        path: '100k-salary-how-much-house-can-you-afford-blog',
        name: '100KSalaryHowMuchHouseCanYouAfford',
        component: () => import('../blog/100KSalaryHowMuchHouseCanYouAfford.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'how-much-house-can-you-really-afford-with-a-fixed-mortgage-blog',
        name: 'HowMuchHouseCanYouReallyAffordwithaFixedMortgage',
        component: () => import('../blog/HowMuchHouseCanYouReallyAffordwithaFixedMortgage.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'why-is-my-mortgage-payment-higher-than-expected-even-with-good-credit-blog',
        name: 'WhyisMyMortgagePaymentHigherThanExpectedEvenwithGoodCredit',
        component: () => import('../blog/WhyisMyMortgagePaymentHigherThanExpectedEvenwithGoodCredit.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'why-did-my-mortgage-payment-go-up-without-refinancing-blog',
        name: 'WhyDidMyMortgagePaymentGoUpWithoutRefinancing',
        component: () => import('../blog/WhyDidMyMortgagePaymentGoUpWithoutRefinancing.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'i-earn-70k-how-much-do-i-actually-take-home-per-month-blog',
        name: 'IEarn70KHowMuchDoIActuallyTakeHomePerMonth',
        component: () => import('../blog/IEarn70KHowMuchDoIActuallyTakeHomePerMonth.vue'),
        meta: { keepAlive: false }
      },
      {
        path: '400k-mortgage-breakdown-where-does-my-money-actually-go-blog',
        name: '400KMortgageBreakdownWhereDoesMyMoneyActuallyGo',
        component: () => import('../blog/400KMortgageBreakdownWhereDoesMyMoneyActuallyGo.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'is-3000-month-too-much-for-a-mortgage-blog',
        name: 'Is3000monthtoomuchforamortgage',
        component: () => import('../blog/Is3000monthtoomuchforamortgage.vue'),
        meta: { keepAlive: false }
      },
      {
        path: 'is-2500-month-too-much-for-a-mortgage-blog',
        name: 'Is2500MonthTooMuchforaMortgage',
        component: () => import('../blog/Is2500MonthTooMuchforaMortgage.vue'),
        meta: { keepAlive: false }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory('/'),
  routes
})

// 添加全局路由守卫
router.beforeEach((to, from, next) => {
  next()
})

// 添加路由解析守卫
router.beforeResolve((to, from, next) => {
  console.log('Route resolving:', to.path)
  next()
})

// 添加路由后置守卫
router.afterEach((to, from) => {
  console.log('Route changed to:', to.path)
  // 可以在这里触发一些全局事件
  window.dispatchEvent(new CustomEvent('route-navigated', { 
    detail: { to: to.path, from: from.path }
  }))
})

export default router
